import SEO from "@/components/SEO";
import FAQAccordion from "@/components/FAQAccordion";
import { RelatedLinks } from "@/pages/ServicePage";
import { PageHero, SectionHead, CTABand, Reveal } from "@/components/Ui";
import { CheckCircle2 } from "lucide-react";

const prestations = [
  "Rénovation de maçonnerie et de façades à Évreux",
  "Réparation de murs et traitement des fissures",
  "Rejointoiement brique, pierre et silex",
  "Reprises de linteaux et renforts localisés",
  "Ouvertures : portes, fenêtres, baies vitrées",
  "Rénovation intérieure et extérieure",
  "Transformation d'espaces et de bâtiments",
  "Travaux liés aux extensions et ouvertures",
];

const faq = [
  { q: "Rénovez-vous les maisons anciennes d'Évreux ?", a: "Oui : briques, pierre et bâti ancien des quartiers d'Évreux font partie de nos chantiers réguliers. Nous rénovons en respectant les matériaux d'origine." },
  { q: "Un mur fissuré, c'est grave ?", a: "Cela dépend de la cause : tassement, humidité, vieillissement. Nous venons diagnostiquer sur place avant de proposer la réparation adaptée — la visite est gratuite." },
  { q: "Pouvez-vous ouvrir un mur porteur lors d'une rénovation ?", a: "Oui, après étude de la configuration existante. Les renforts (linteau, poutre, jambages) sont dimensionnés selon votre bâtiment." },
];

export default function RenovationEvreux() {
  return (
    <>
      <SEO
        title="Rénovation de maison à Évreux | Rénovation maçonnerie – DMZ Normandie"
        description="Rénovation de maison à Évreux : réparation de murs, fissures, rejointoiement, ouvertures de murs porteurs. DMZ Normandie — devis gratuit, 07 45 04 91 89."
        path="/renovation-evreux"
      />
      <PageHero
        title="Rénovation de maison à Évreux"
        subtitle="Une façade fatiguée, des fissures, une maison à transformer ? Basée à Évreux, DMZ Normandie rénove votre maçonnerie avec sérieux — diagnostic gratuit sur place."
      />

      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14">
          <Reveal delay={0.05} className="order-2 lg:order-1 space-y-6">
            <div className="overflow-hidden relative">
              <img src="/realisations/facade-apres-bernay.webp" alt="Rénovation de maçonnerie dans l'Eure : façade rénovée avec encadrements brique par DMZ Normandie" className="w-full h-80 object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-black/25" />
            </div>
            <div className="card-dark p-8">
              <h2 className="font-serif-display font-light text-2xl md:text-3xl text-[#F5F5F0] mb-4">Un diagnostic avant tout</h2>
              <p className="text-sm font-light text-zinc-400 leading-relaxed">
                Une rénovation réussie commence par comprendre le bâti. Nous identifions les causes
                des désordres — humidité, tassement, vieillissement — avant de proposer la réparation
                la plus juste, ni plus ni moins.
              </p>
              <p className="mt-4 text-sm font-light text-zinc-400 leading-relaxed">
                Basés à Évreux, nous passons rapidement pour voir votre maison et vous remettre un
                devis gratuit, clair et détaillé.
              </p>
            </div>
          </Reveal>
          <Reveal className="order-1 lg:order-2">
            <SectionHead overline="Nos prestations" title="La rénovation, du mur fissuré à la façade" />
            <div className="space-y-4 -mt-6">
              {prestations.map((p) => (
                <p key={p} className="flex items-start gap-3 text-zinc-300 font-light">
                  <CheckCircle2 size={18} className="text-[#C4A484] mt-0.5 shrink-0" /> {p}
                </p>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="max-w-4xl mx-auto px-6 lg:px-10 mt-20">
          <SectionHead overline="Questions fréquentes" title="Vos questions, nos réponses" />
          <FAQAccordion items={faq} testid="faq-renovation-evreux" />
        </div>

        <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-16">
          <Reveal>
            <p className="text-[10px] tracking-[0.5em] uppercase text-[#C4A484] mb-5">Voir aussi</p>
            <RelatedLinks slugs={["maconnerie-evreux", "renovation-bernay", "rejointoiement", "ouverture-mur-porteur", "zones"]} />
          </Reveal>
        </div>
      </section>

      <CTABand />
    </>
  );
}
